import React from "react";
import ServiceSlide from "./services/ServiceSlide";
import CourseSlide from "./courses/CourseSlide";
import GoogleReviews from "./home/GoogleReviews";
import Feature from "./home/Feature";
import Hero from "./home/Hero";
import CTA from "./home/CTA";
import STATS from "./home/STATS";
import ProductsSection from "./home/ProductsSection"; // ← add

const Home = () => {
	return (
		<div>
		<Hero />  
		
		<ProductsSection />   {/* ← add wherever you want it in the flow */}
		<CTA />
		<ServiceSlide />
		<CourseSlide />
		<Feature />  
		<STATS/>
		<GoogleReviews />
		</div>
		);
	};
	export default Home;